module.exports = __webpack_public_path__ + "img/cli_06.dec7ecbb.png";